import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61ab985e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "topic-rank-pc"
};
const _hoisted_2 = {
  key: 0,
  class: "board"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rsaquo"
}, "›", -1));
const _hoisted_4 = {
  class: "group group1"
};
const _hoisted_5 = {
  class: "topic-header"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 话题榜", -1));
const _hoisted_7 = {
  class: "topic-content"
};
const _hoisted_8 = {
  class: "topic-pic"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "topic-title"
};
const _hoisted_11 = {
  key: 0,
  class: "no-topic-data"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "暂无数据", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_image_cdn = _resolveComponent("image-cdn");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.data && $props.notLimitSelectLayer1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("h3", null, [_createVNode(_component_router_link, {
    class: "more",
    to: {
      name: 'topicrank'
    }
  }, {
    default: _withCtx(() => [_createTextVNode(" 更多"), _hoisted_3]),
    _: 1
  }), _createElementVNode("span", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createVNode(_component_image_cdn, {
    class: "topic-header-icon",
    src: require('@/assets/images/pc/icons/ico-heat-board.png')
  }, null, 8, ["src"])]), _hoisted_6])]), _createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (topic, idx) => {
    return _openBlock(), _createElementBlock("li", {
      key: idx
    }, [_createElementVNode("span", {
      class: _normalizeClass(["rank", $setup.rankClass(idx)])
    }, _toDisplayString(idx + 1), 3), _createVNode(_component_router_link, {
      class: "topic-author",
      to: {
        name: 'topic',
        params: {
          id: topic.id,
          query: ['hot']
        }
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [topic.pic ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.$filters.cdnUrlFormat('/' + topic.pic),
        alt: "",
        onError: _cache[0] || (_cache[0] = (...args) => $setup.imageFail && $setup.imageFail(...args)),
        onLoad: _cache[1] || (_cache[1] = (...args) => $setup.imageLoad && $setup.imageLoad(...args))
      }, null, 40, _hoisted_9)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_10, "#" + _toDisplayString(topic.name) + "#", 1), _createElementVNode("div", null, [_createElementVNode("span", null, "热度 " + _toDisplayString(topic.hot_point), 1), _createElementVNode("span", null, "帖子 " + _toDisplayString(topic.thread), 1), _createElementVNode("span", null, "今日讨论 " + _toDisplayString(topic.replies), 1)])])]),
      _: 2
    }, 1032, ["to"])]);
  }), 128)), !$props.data || $props.data.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_image_cdn, {
    src: require('@/assets/h5/icons/ic-no-data.svg'),
    width: "42",
    height: "36",
    alt: ""
  }, null, 8, ["src"]), _hoisted_12])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
}